import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import qs from 'qs';

import Pagination from '../../../components/Pagination/Pagination';
import { fetchAllSimoSubs } from '../../../actions/simoSubs';
import { fetchAllPlans } from '../../../actions/simoPlans';
import {
  getAllSimoPlans,
  getAllSimoSubs,
  getPageCount,
} from '../../../reducers';
import OrderedSubList from '../../../components/OrderedSubList/OrderedSubList';
import { simoStatuses } from 'helpers/subs';
import Spinner from 'components/Spinner';

class AllSimoSubs extends Component {
  state = {
    loading: false,
  };

  componentDidMount() {
    this.fetchAllSimoSubs();
    this.props.fetchAllPlans();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.page !== this.props.page) {
      this.fetchAllSimoSubs();
    }

    if (
      oldProps.ordering !== this.props.ordering ||
      oldProps.status !== this.props.status ||
      oldProps.plan_id !== this.props.plan_id
    ) {
      this.fetchAllSimoSubs();
    }
  }

  fetchAllSimoSubs() {
    const { fetchAllSimoSubs, page, ordering, status, plan_id } = this.props;
    let filters = {};
    if (status) {
      filters.simo_status = status;
    }
    if (plan_id) {
      filters.plan = plan_id;
    }
    this.setState({ loading: true });
    fetchAllSimoSubs(page, ordering, filters).finally(() =>
      this.setState({ loading: false }),
    );
  }

  handleChangeOrdering = (value) => {
    const { history } = this.props;
    history.push({
      search: this.getSearchUrlPart({ ordering: value }),
    });
  };

  handleChangePlanId = (e) => {
    const value = e.target.value;
    const { page, history } = this.props;
    if (page && page.toString() !== '1') {
      history.push({
        pathname: `/simo/subscriptions/page/1`,
        search: this.getSearchUrlPart({ plan_id: value }),
      });
    } else {
      history.push({
        search: this.getSearchUrlPart({ plan_id: value }),
      });
    }
  };

  handleChangeStatus = (e) => {
    const value = e.target.value;
    const { page, history } = this.props;
    if (page && page.toString() !== '1') {
      history.push({
        pathname: `/simo/subscriptions/page/1`,
        search: this.getSearchUrlPart({ status: value }),
      });
    } else {
      history.push({
        search: this.getSearchUrlPart({ status: value }),
      });
    }
    history.push({
      search: this.getSearchUrlPart({ status: value }),
    });
  };

  getSearchUrlPart = (newPartObj = {}) => {
    const { plan_id, status, ordering } = this.props;
    let queries = [];

    if (typeof newPartObj.plan_id !== 'undefined') {
      queries.push(`plan_id=${newPartObj.plan_id}`);
    } else {
      queries.push(`plan_id=${plan_id}`);
    }

    if (typeof newPartObj.status !== 'undefined') {
      queries.push(`status=${newPartObj.status}`);
    } else {
      queries.push(`status=${status}`);
    }

    if (newPartObj.ordering || ordering) {
      queries.push(`ordering=${newPartObj.ordering || ordering}`);
    }

    return `?${queries.join('&')}`;
  };

  render() {
    const { subs, pageCount, page, ordering, plans, plan_id, status } =
      this.props;
    const { loading } = this.state;

    const plansOptions = plans.map((plan) => [
      plan.id,
      `${plan.id} - ${plan.name}`,
    ]);
    const statusesOptions = simoStatuses.map((status) => [status, status]);
    return (
      <div>
        <h1>All Simo Subscriptions</h1>
        <div className="d-flex">
          <div
            style={{ width: 'calc(50% - 15px)', marginRight: '15px' }}
            className="form-group"
          >
            <label>Status</label>
            <select
              onChange={this.handleChangeStatus}
              className="form-control"
              value={status}
            >
              <option value="">Any</option>
              {statusesOptions.map((option) => (
                <option key={option[0]} value={option[0]}>
                  {option[1]}
                </option>
              ))}
            </select>
          </div>
          <div
            style={{ width: 'calc(50% - 15px)', marginLeft: '15px' }}
            className="form-group"
          >
            <label>Plan</label>
            <select
              onChange={this.handleChangePlanId}
              className="form-control"
              value={plan_id}
            >
              <option value="">Any</option>
              {plansOptions.map((option) => (
                <option key={option[0]} value={option[0]}>
                  {option[1]}
                </option>
              ))}
            </select>
          </div>
        </div>
        <OrderedSubList
          subs={subs}
          ordering={ordering}
          changeOrdering={this.handleChangeOrdering}
          statusKey="simo_status"
          viewUrl={(subId) => `/simo/subscriptions/${subId}/view`}
          showEffectiveDate
          isSimo
        />
        <Pagination
          count={pageCount}
          current={page}
          url={(pageNum) =>
            `/simo/subscriptions/page/${pageNum}${this.getSearchUrlPart()}`
          }
        />
        <Spinner showLoader={loading} />
      </div>
    );
  }
}

const mapStateToProps = (
  state,
  {
    match: {
      params: { page = 1 },
    },
    location: { search },
  },
) => {
  const {
    ordering = '-id',
    plan_id = '',
    status = '',
  } = qs.parse(search, { ignoreQueryPrefix: true });
  return {
    subs: getAllSimoSubs(state, page),
    pageCount: getPageCount(state, 'simoSubs', 'fetchAll', page),
    page,
    plans: getAllSimoPlans(state),
    ordering,
    plan_id,
    status,
  };
};

const mapDispatchToProps = {
  fetchAllSimoSubs,
  fetchAllPlans,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AllSimoSubs),
);
